import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';

import type { SchoolTodayCard } from './TodayCard.js';

// Schoolplanner (0076): de kaart op Vandaag zit in een eigen chunk; Vandaag importeert alleen dit.

const card = signal<typeof SchoolTodayCard | null>(null);

export function LazySchoolTodayCard(props: { tick: number }) {
  useEffect(() => {
    if (!card.value) {
      void import('./TodayCard.js')
        .then((m) => (card.value = m.SchoolTodayCard))
        .catch(() => undefined);
    }
  }, []);
  const C = card.value;
  return C ? <C {...props} /> : null;
}
